<template lang="pug">
div
  p.label-subitem {{ validacao.label }}
    el-table(:data="validacao.dados", :show-header="false")
      el-table-column(
        prop="campo"
      )
      //- Coluna de válidos
      el-table-column(
        prop="isValido"
        align="left",
        width="180"
      )
        template(slot-scope="scope")
          .valido(v-if="scope.row.valido")
            font-awesome-icon(icon="check", size="lg")
            span &nbsp Válido
          .invalido(v-else-if="scope.row.valido === false")
            font-awesome-icon(icon="times", size="lg")
            span &nbsp Inválido
</template>

<script>
export default {
  props: {
    validacao: {
      required: true
    }
  }

}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.label-subitem {
  padding-top: 10px;
  color: rgb(112, 112, 112);
}

.valido {
  color: #009c66;
  width: 50%;
}

.invalido {
  color: firebrick;
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/AppItemDespachoAutomatizadoValido.vue